const getText = (key: string) =>
  `Are you sure you want to disable flights by ${key}? This action may delete previously created flights.`;

const getTitle = (key: string) => `Disable flights by ${key}`;

const getMetadata = (key: string) => ({
  text: getText(key),
  title: getTitle(key)
});

export const modalsMetadata = {
  automaticHandicaps: getMetadata('Automated Handicap'),
  flightsByAge: getMetadata('Age'),
  flightsByGender: getMetadata('Gender'),
  flightsByHandicap: getMetadata('Index'),
  useFlights: {
    text: '',
    title: ''
  }
};
